import { render, staticRenderFns } from "./ChairmanMessage.vue?vue&type=template&id=2501d800&scoped=true&"
import script from "./ChairmanMessage.vue?vue&type=script&lang=js&"
export * from "./ChairmanMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChairmanMessage.vue?vue&type=style&index=0&id=2501d800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501d800",
  null
  
)

export default component.exports